<template>
  <el-card class="h-full relative">
    <div class="flex mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入隐患描述"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.hiddenDangerSource"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择隐患来源"
        clearable
      >
        <el-option
          v-for="item in hiddenSourceList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.hiddenDangerlevel"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择隐患等级"
        clearable
      >
        <el-option
          v-for="item in hiddenLevelList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>

      <!-- <el-select
        v-model="searchData.ownedSystemOrUnit"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择所属系统/机组"
        clearable
      >
        <el-option
          v-for="item in ownedSystemOrUnitList"
          :key="item.id"
          :label="item.displayName"
          :value="item.id"
        ></el-option>
      </el-select> -->

      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" @click="resetSearch">重置</el-button>
      <el-button
        size="small"
        @click="handleEvent(null, 'export')"
        :disabled="!$hasAccess('export')"
      >
        批量导出
      </el-button>
    </div>
    <el-table
      ref="table"
      :data="tableData"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="loading"
      @selection-change="handleSelection"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="隐患描述"
        prop="hiddenDangerName"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="隐患等级"
        prop="hiddenDangerlevelStr"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="隐患类别"
        prop="hiddenDangerCategoryStr"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        label="所在区域"
        prop="areaStr"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="隐患来源"
        prop="hiddenDangerSourceStr"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        label="所属机组/系统"
        prop="ownedSystemOrUnitText"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column
        label="状态"
        prop="acceptanceStatusStr"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        label="隐患类型"
        prop="hiddenDangerTypeStr"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column
        label="安全检查标题"
        prop="safetyInspectionTitle"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="安全检查期数"
        prop="safetyInspectionPeriods"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="隐患上报人"
        prop="reporterName"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="上报时间" prop="reportTime" show-overflow-tooltip width="180px">
        <template slot-scope="scope">
          {{
            scope.row.reportTime ? dayjs(scope.row.reportTime).format('YYYY-MM-DD HH:mm:ss') : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="隐患整改负责人"
        prop="personChargeHiddenDangerRectificationName"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="140">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="
              !(
                $hasAccess('update') &&
                scope.row.acceptanceStatus === 0 &&
                scope.row.auditPermission
              )
            "
            @click="handleEvent(scope.row, 'update')"
            >验收</el-button
          >
          <el-button
            size="mini"
            @click.native="handleEvent(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="searchList"
      @current-change="findList"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="total"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
    <HiddenAcceptForm
      v-if="formDialog"
      :formProps="formProps"
      :FormData="FormData"
      @refreshList="refreshList()"
      @cancel="handleCancel"
    />
    <!-- <ChangeSingle :formData="cardDetail" v-if="isSingle" @cancel="isSingle = false"></ChangeSingle> -->
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import axios from 'axios'
import qs from 'qs'
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import HiddenAcceptForm from '../../components/HiddenAccept/HiddenAcceptForm'
// import ChangeSingle from '../../components/HiddenRectification/ChangeSingle'

const areaApi = new AreaApi()
const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'hidden-accept',
  components: {
    HiddenAcceptForm,
    // ChangeSingle,
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      ownedSystemOrUnitList: [],
      hiddenDangerRectificationStatusList: [
        { displayName: '待整改', code: 0 },
        { displayName: '整改中', code: 1 },
        { displayName: '已整改', code: 2 },
        { displayName: '超期未整改', code: 3 },
        { displayName: '延期审核中', code: 4 },
      ],

      FormData: {},
      formDialog: false,
      detailDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      hiddenSourceList: [],
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],

      // 整改单
      cardDetail: {},
      isSingle: false,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  created() {
    const id = this.$route.query.id
    const flowTaskId = this.$route.query.taskId
    // 待办-验收
    if (id && this.$route.query.mode) {
      this.initDialog(
        { id, currentWorkflowTaskId: flowTaskId },
        this.$route.query.mode === 'approve' ? 'update' : 'read'
      )
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
    this.searchList()
    this.getAreaList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.investigationTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.investigationTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.investigationTimeStart = ''
        this.searchData.investigationTimeEnd = ''
      }
    },
  },
  methods: {
    /**
     * 刷新列表
     */
    refreshList() {
      this.findList()
    },
    /**
     * 返回
     */
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
        acceptanceStatus: 0 // 待验收
      }
      // 低代码
      if (window.__POWERED_BY_QIANKUN__) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res1 = await instance.get(
          `/api/double-prevention-management/hidden-danger-rectification-checklists/paged-acceptance-list-query?${qs.stringify(
            data
          )}`
        )
        if (res1.status === 200 && res1.data) {
          this.tableData = res1.data.items
          this.total = res1.data.totalCount
          this.loading = false
        }
        return
      }
      const [err, res] =
        await hiddenDangerRectificationChecklistApi.hiddenDangersAcceptancePagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'export':
          // if (!this.selectionData || this.selectionData.length === 0) {
          //   this.$message({
          //     showClose: true,
          //     message: '请勾选要导出的记录',
          //     type: 'warning',
          //   })
          //   return
          // }
          this.export()
          break
        default:
          break
      }
    },
    async export() {
      const [err, res] =
        await hiddenDangerRectificationChecklistApi.hiddenDangersAcceptanceExportToExcelFile({
          hiddenDangersReporteIds: this.selectionData,
          returnType: 'Blob',
        })
      if (!err) {
        this.downLoadExcel('隐患验收数据', res)
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }隐患信息`
      if (operation === 'create') {
        this.FormData = this.$options.data().FormData
      } else {
        let resVal = {}
        if (window.__POWERED_BY_QIANKUN__) {
          // 低代码
          const instance = axios.create()
          instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
          const token = localStorage.getItem('authorization')
          instance.defaults.headers.common.Authorization = `Bearer ${token}`
          const result = await instance.get(
            `api/double-prevention-management/hidden-danger-rectification-checklists/${row.id}`
          )
          if (result.status === 200 && result.data) {
            resVal = result.data
          }
        } else {
          const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
          if (!err) {
            resVal = res
          }
        }
        if (row.workflowTaskId) {
          resVal.workflowTaskId = row.workflowTaskId
        }
        if (row.currentWorkflowTaskId) {
          resVal.currentWorkflowTaskId = row.currentWorkflowTaskId
        }
        if (row.currentWorkflowDelayTaskId) {
          resVal.currentWorkflowDelayTaskId = row.currentWorkflowDelayTaskId
        }
        this.FormData = resVal
      }
      this.formDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
